import React from "react";
import { useTranslation } from "react-i18next";
import { motion } from "framer-motion";
import {
  FaPrayingHands,
  FaOm,
  FaFire,
  FaLeaf,
  FaBell,
  FaStar,
} from "react-icons/fa";

const NoticeSection = () => {
  const { t } = useTranslation();

  const notices = [
    { key: "ssp", icon: <FaPrayingHands /> },
    { key: "km", icon: <FaPrayingHands /> },
    { key: "sp", icon: <FaPrayingHands /> },
    { key: "nm", icon: <FaPrayingHands /> },
    { key: "up", icon: <FaPrayingHands /> },
    { key: "sbp", icon: <FaPrayingHands /> },
  ];

  return (
    <div className="notice-container">
      <motion.div
        className="notice-title"
        initial={{ opacity: 0, y: -40 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
      >
        <h2>{t("iv")}</h2>
      </motion.div>

      <div className="notice-grid">
        {notices.map((item, index) => (
          <motion.div
            key={index}
            className="notice-card"
            initial={{ opacity: 0, y: 50 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{
              delay: index * 0.15,
              duration: 0.5,
              type: "spring",
            }}
            whileHover={{ scale: 1.05 }}
          >
            <div className="icon">{item.icon}</div>
            <h3>{t(item.key)}</h3>
          </motion.div>
        ))}
      </div>
    </div>
  );
};

export default NoticeSection;